import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/jobsFinder/jobsFinderSlice";
import JobsFinderHeader from "./JobsFinderHeader";
import JobsFinderList from "./JobsFinderList";

export default function JobsFinderIndex() {
  const dispatch = useDispatch();
  const jobsState = useSelector((state) => state.jobs);
  const { sortSearchFilter, jobTypeFilter } = jobsState || {};
  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch, sortSearchFilter]);

  let content = null;

  content =
    sortSearchFilter?.length > 0 || sortSearchFilter === ""
      ? jobListContentSearchSort(sortSearchFilter)
      : jobTypeFilter?.length > 0 ? jobListContentTypeFilter(jobTypeFilter) : jobsListContent(jobsState);

  return (
    <>
      <div className="lg:pl-[14rem]  mt-[5.8125rem]">
        <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
          <JobsFinderHeader />
          <div className="jobs-list">{content}</div>
        </main>
      </div>
    </>
  );
}

export function jobsListContent(jobsState) {
  const { jobs, isLoading, isError } = jobsState;
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occur</p>;

  if (!isLoading && !isError && jobs?.length > 0) {
    content = jobs.map((job) => <JobsFinderList key={job.id} job={job} />);
  }

  if (!isLoading && !isError && jobs?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  return content;
}

export function jobListContentSearchSort(sortSearchFilter) {
  let content = null;
  if (sortSearchFilter?.length > 0) {
    content = sortSearchFilter.map((job) => (
      <JobsFinderList key={job.id} job={job} />
    ));
  }

  if (sortSearchFilter?.length === 0) {
    content = <p>No transactions found! Search Result 0.</p>;
  }

  return content;
}

export function jobListContentTypeFilter(jobTypeFilter) {
  let content = null;
  if (jobTypeFilter?.length > 0) {
    content = jobTypeFilter.map((job) => (
      <JobsFinderList key={job.id} job={job} />
    ));
  }

  if (jobTypeFilter?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  return content;
}
